import React from 'react';
import { styled } from '@mui/material/styles';
import { useFullScreen } from 'contexts/FullScreenContext';

type Props = {
    children?: React.ReactNode;
    className?: string;
};

const StyAgContainer = styled('div', {
    name: 'StyAgContainer',
    shouldForwardProp: (prop) => prop !== 'isFullScreen',
})<{ isFullScreen: boolean }>(({ isFullScreen }) => ({
    width: '100%',
    height: isFullScreen ? '100%' : '90vh',
    '&& .ag-root-wrapper': {
        borderBottomLeftRadius: '4px',
        borderBottomRightRadius: '4px',
    },
    '.ag-row .ag-center-cols-container': {
        // Ag Grid defines the width of the this element with inline styling.
        // !important is the only way to have better selectivity and overwrite the width.
        width: 'max(1355px, 100%) !important',
    },
    '.ag-row.ag-row-level-1': {
        width: 'max(1355px, 100%)',
    },
    '.ag-row .ag-center-cols-viewport': { overflowX: 'hidden' },
    '.ag-row .ag-header': {
        height: '36px !important',
        minHeight: '36px !important',
    },
}));

const AgContainer = ({ className, children }: Props) => {
    const { isFullScreen } = useFullScreen();
    return (
        <StyAgContainer className={className} isFullScreen={isFullScreen}>
            {children}
        </StyAgContainer>
    );
};

export default AgContainer;
